import { render, staticRenderFns } from "./UonPage.vue?vue&type=template&id=2797643a&"
import script from "./UonPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./UonPage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports